/**
 * BroadcastChannel-based real-time sync between Catalogue List and Lookbook tabs.
 * Channel: catalogue_sync_channel
 */

import type { ItemRow, AirlineTier } from '../types';

export const SYNC_CHANNEL_NAME = 'catalogue_sync_channel';

export type SyncMessage =
  | {
      type: 'SETTINGS_CHANGE';
      airlineMode: boolean;
      showIngredients: boolean;
      showPrices: boolean;
      showDefrostLife?: boolean;
      showHandling?: boolean;
      tierEntries: [number, AirlineTier][];
    }
  | {
      type: 'SELECTION_CHANGE';
      selectedIds: number[];
    }
  | {
      type: 'PRODUCT_UPDATE';
      itemid: number;
      patch: Partial<ItemRow>;
    };

/** Post a message to the sync channel (fire-and-forget). */
export function postSyncMessage(msg: SyncMessage): void {
  try {
    const ch = new BroadcastChannel(SYNC_CHANNEL_NAME);
    ch.postMessage(msg);
    ch.close();
  } catch {
    // BroadcastChannel not supported (e.g. older Safari) — silently ignore
  }
}
